import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-retraite-complementaire-salarie',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-retraite-complementaire-salarie.component.html',
  styleUrls: ['./assurance-retraite-complementaire-salarie.component.scss']
})
export class AssuranceRetraiteComplementaireSalarieComponent {
  title = 'Assurance Retraite Complémentaire Salarié';
  subtitle = '';
  heroVideo = 'assets/videos/retraite.mp4';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Retraite', link: undefined }
  ];

  prevPage = { title: 'Prévoyance Décès',
    link: '/assurance-prevoyance-deces'
  };

  nextPage = { title: 'Voyage Personnel',
    link: '/assurance-voyage-personnel'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'CARDIF', logo: 'assets/images/logos/cardif-logo.png' },
    { name: 'NEOLIANE', logo: 'assets/images/logos/neoliane-logo.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/devis']);
  }
}

